import React, { useState } from 'react'
import { useTranslation } from 'i18n'

import { Field, Formik } from 'formik'
import * as yup from 'yup'

import ProductOverview from './parts/ProductOverview'
import { TurnstileWidget } from 'components/TurnstileWidget'

import { renderTextInput } from './formik-util'

const reminderForm = yup.object().shape({
  email: yup
    .string()
    .email('Please specify a valid email address')
    .required('Email is a required field')
    .trim(),
})

const ReminderScreen = ({
  review,
  defaultProductId,
  defaultEmail,
  onSubmit,
}) => {
  // console.log("ReminderScreen render")
  defaultProductId = defaultProductId
    ? defaultProductId
    : review.products[0].productId

  const { t } = useTranslation('review')
  const [productId, setProductId] = useState(defaultProductId)

  // useEffect(() => {
  //     setProductId(defaultProductId);
  // }, [defaultProductId])

  let product = review.products.find(product => {
    return product.productId === productId
  })

  const handleProductSelect = (id, label) => {
    setProductId(id)
  }

  if (!product) {
    product = review.products[0]
  }

  // formik
  let initialValues = {
    email: defaultEmail ? defaultEmail : '',
    productId: productId,
  }

  return (
    <div className={`reminder-screen`}>
      <h1 dangerouslySetInnerHTML={{ __html: review.reminderIntroTitle }} />
      <div
        className="detail"
        dangerouslySetInnerHTML={{ __html: review.reminderIntroDescription }}
      />

      <ProductOverview
        products={review.products}
        defaultProductId={productId}
        onProductSelect={handleProductSelect}
      />

      <form>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validateOnBlur={true}
          validateOnChange={true}
          validationSchema={reminderForm}
          onSubmit={(values, { setSubmitting }) => {
            onSubmit(values.email, values.productId, values.turnstileToken)
          }}
        >
          {formik => {
            return (
              <>
                <TurnstileWidget
                  mode="invisible"
                  onToken={token =>
                    formik.setFieldValue('turnstileToken', token)
                  }
                />
                <Field
                  key={`email`}
                  name={`email`}
                  type="email"
                  label={t('reminder.emailLabel')}
                  placeholder={t('reminder.emailLabel')}
                  component={renderTextInput}
                  fullWidth={true}
                  error={formik.errors[`email`]}
                  touched={formik.touched[`email`] && true}
                />

                <button
                  type="submit"
                  className={`complete`}
                  disabled={formik.isSubmitting || !formik.isValid}
                  onClick={formik.handleSubmit}
                >
                  {t('reminder.submitCta')}
                </button>
              </>
            )
          }}
        </Formik>
      </form>
    </div>
  )
}

export default ReminderScreen
